import { Phone } from "lucide-react";
import { DOCTORS, PHONE_LINK, Reveal, Eyebrow } from "../lib/data";

const Doctors = () => (
  <section id="echipa" className="py-20 lg:py-28 bg-white" data-testid="doctors-section">
    <div className="max-w-7xl mx-auto px-6">
      <Reveal className="max-w-2xl">
        <Eyebrow>Echipa medicală</Eyebrow>
        <h2 className="font-display text-3xl lg:text-4xl font-bold text-[#2A2521] mt-3">
          Medici dedicați zâmbetului tău
        </h2>
        <p className="text-[#6B5C43] mt-4 text-base md:text-lg">
          Medici care îți cunosc numele și îți respectă timpul.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-5">
        {DOCTORS.map((d, i) => (
          <Reveal key={d.id} delay={i * 0.08}>
            <div
              data-testid={`doctor-card-${d.id}`}
              className="group h-full flex flex-col bg-[#FBF7EF] rounded-2xl border border-[#EADFC6] overflow-hidden hover:shadow-xl hover:shadow-[#A6823B]/10 hover:-translate-y-1 transition-all"
            >
              <div className="aspect-[3/4] overflow-hidden bg-[#EFE7D6]">
                {d.photo ? (
                  <img
                    src={d.photo}
                    alt={d.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    loading="lazy"
                  />
                ) : (
                  <div className="w-full h-full flex flex-col items-center justify-center gap-2">
                    <span className="w-16 h-16 rounded-full bg-[#A6823B]/15 text-[#A6823B] flex items-center justify-center font-display font-extrabold text-2xl">
                      {d.name.split(" ").pop()[0]}
                    </span>
                    <span className="text-xs text-[#8A7A5E]">Fotografie în curând</span>
                  </div>
                )}
              </div>
              <div className="p-5 flex flex-col flex-1">
                <span className="text-xs font-semibold uppercase tracking-widest text-[#A6823B] block min-h-[2.4em]">{d.spec}</span>
                <h3 className="font-display font-bold text-[#2A2521] mt-1.5">{d.name}</h3>
                <p className="text-sm text-[#8A7A5E] mt-0.5">{d.role}</p>
                <p className="text-sm text-[#6B5C43] mt-2.5 leading-relaxed flex-1">{d.bio}</p>
                <a
                  href={PHONE_LINK}
                  data-testid={`doctor-cta-${d.id}`}
                  className="mt-auto pt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#A6823B] hover:text-[#8A6B2E] transition-colors"
                >
                  <Phone className="w-4 h-4" /> Programează consult
                </a>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Doctors;
